import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMagicWand: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="magic-wand, magic stick, star"><path d="M18.95 5.05024L17.1115 9.50722L20.2373 13.1779L15.4303 12.8067L12.9052 16.9138L11.7729 12.2274L7.08643 11.095L11.1936 8.56992L10.8223 3.76294L14.493 6.88877L18.95 5.05024Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 20.2499L11.1933 12.8066" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconMagicWand;
